/** Filter inbox-style message rows for the sentiment theme drawer (API-fed list). */
export function filterMessagesByTheme(messages, sentiment, theme, options = {}) {
  const { dateRange, platformFilter, searchQuery = "", sortOption = "recent" } = options
  const list = Array.isArray(messages) ? messages : []
  let filtered = list.filter((m) => {
    if (m.sentimentLabel !== sentiment) return false
    const termLower = (theme || "").toLowerCase()
    if (!termLower || !m.text) return false
    if (!m.text.toLowerCase().includes(termLower)) return false
    if (dateRange?.start && m.createdAt) {
      const msgDate = m.createdAt.slice(0, 10)
      if (msgDate < dateRange.start) return false
    }
    if (dateRange?.end && m.createdAt) {
      const msgDate = m.createdAt.slice(0, 10)
      if (msgDate > dateRange.end) return false
    }
    if (
      platformFilter &&
      platformFilter !== "all" &&
      Array.isArray(platformFilter) &&
      platformFilter.length > 0
    ) {
      if (!platformFilter.includes(m.platform)) return false
    }
    if (
      platformFilter &&
      platformFilter !== "all" &&
      !Array.isArray(platformFilter) &&
      platformFilter !== m.platform
    ) {
      return false
    }
    if (searchQuery && searchQuery.trim()) {
      if (!m.text.toLowerCase().includes(searchQuery.trim().toLowerCase())) return false
    }
    return true
  })

  if (sortOption === "recent") {
    filtered.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
  } else if (sortOption === "score_asc") {
    filtered.sort((a, b) => (a.sentimentScore || 0) - (b.sentimentScore || 0))
  } else if (sortOption === "score_desc") {
    filtered.sort((a, b) => (b.sentimentScore || 0) - (a.sentimentScore || 0))
  }

  return filtered
}
